module["exports"] = [
  "India",
  "Indian Republic",
  "Bharat",
  "Hindustan"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IND/address/default_country.js
// module id = 561
// module chunks = 0